/* eslint-disable */
// prettier-ignore
export default {
  pages: {
    key: 'title',
    data: [
      { title: 'Campaigns', route: { name: 'bulk-campaigns' }, icon: 'MessageSquareIcon', isBookmarked: false },
      { title: 'Address Books', route: { name: 'address-books' }, icon: 'BookIcon', isBookmarked: false },
      { title: 'Senders', route: { name: 'senders' }, icon: 'HashIcon', isBookmarked: false },
      { title: 'Outbox', route: { name: 'outbox' }, icon: 'LogOutIcon', isBookmarked: false },
      { title: 'API Outbox', route: { name: 'api-outbox' }, icon: 'LogOutIcon', isBookmarked: false },
      { title: 'StopList', route: { name: 'stoplist' }, icon: 'AlertOctagonIcon', isBookmarked: false },
    ],
  },
  files: {
    key: 'file_name',
    data: [],
  },
  contacts: {
    key: 'name',
    data: [],
  },
}
/* eslint-enable */
